import { Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AddEditNewCategory from "../../../components/ClientDialog/AddEditNewCategory";
import GlobalButton from "../../../components/CustomButton";
import CategoryBlockDialog from "../../../components/Dialog/CategoryBlockDialog";
import DynamicTable from "../../../components/DynamicTable";
import appcolors from "../../../constants/Colors";

const headerData = ["Created Date", "Category Name", "Branch Name", "Actions"];

const tableRows = ["date_time", "category_name", "branch_category", "actions"];

function Categories(props) {
  const {
    openCategoryDialog,
    openConfirmDialog,
    setOpen,
    open,
    category,
    handleConfirm,
    openConfirm,
    handleDelete,
    handleAddCategory,
    setOpenConfirm,
    inputError,
    handleEdit,
    inputValues,
    handleClose,
    setInputValues,
    handleChageInputs,
    handleAddEditCategory,
    setSelectedBranches,
    selectedBranches,
  } = props;

  const { user } = useSelector((state) => state.user);

  const renderRightPart = () => {
    return (
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <GlobalButton
          variant={"contained"}
          btnText={"Add New"}
          handleClickBtn={handleAddCategory}
          styleProps={{
            fontWeight: 400,
            fontSize: "0.875rem",
            height: 40,
            width: 120,
          }}
        />
      </Stack>
    );
  };

  return (
    <AppContainer
      primaryHeading={"All Category"}
      secondaryHeading={"View, edit and delete category"}
      headProps={renderRightPart()}
    >
      {category?.length > 0 ? (
        <DynamicTable
          showEdit={true}
          tableData={category}
          handleEdit={handleEdit}
          displayRows={tableRows}
          tableHeader={headerData}
          handleDelete={handleDelete}
          handleChangeStatus={() => console.log()}
        />
      ) : (
        <Typography
          variant="h1"
          fontSize={23}
          textAlign={"center"}
          color={appcolors.black}
          mt={20}
          mb={20}
        >
          No Category Found!
        </Typography>
      )}
      <AddEditNewCategory
        ref={openCategoryDialog}
        open={open}
        setOpen={setOpen}
        inputError={inputError}
        selectedBranches={selectedBranches}
        setSelectedBranches={setSelectedBranches}
        handleClose={handleClose}
        inputValues={inputValues}
        setInputValues={setInputValues}
        handleChageInputs={handleChageInputs}
        handleAddEditNewCategory={handleAddEditCategory}
      />
      <CategoryBlockDialog
        ref={openConfirmDialog}
        handleConfirm={handleConfirm}
        open={openConfirm}
        setOpen={setOpenConfirm}
      />
    </AppContainer>
  );
}

export default Categories;
